import { render } from "./UpdateOrder.vue?vue&type=template&id=6943ca12&scoped=true"
import script from "./UpdateOrder.vue?vue&type=script&lang=js"
export * from "./UpdateOrder.vue?vue&type=script&lang=js"

import "./UpdateOrder.vue?vue&type=style&index=0&id=6943ca12&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6943ca12"]])

export default __exports__